export const ProductCategoryColors = {
  Papinhas: '#ff73c3',
  'Fórmulas infantis': '#5082c9',
  'Compostos lácteos': '#65ac28',
  Mucilon: 'rgb(239, 133, 27)'
};
